import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { Button, InputAdornment } from "@mui/material";
import { logoStyle, textfield, lebelStyle, max_width } from "../../style/style";
import EditIcon from "@mui/icons-material/Edit";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { updateobj, getobj } from "../../apicall/apicall";
import { NotificationManager } from "react-notifications";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { validated } from "../../apicall/validateform";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { profile, customer } from "../../apicall/constants";
import { validateForms } from "../../apicall/commonFunction";

export default function DistributorProfile(props) {
  const [basic, setbasic] = useState(props.distributor);
  const [customerinfo, setcustomerinfo] = useState(false);
  const [updateemailDialogue, setupdateemaildialogue] = useState(false);
  const [editProfile, seteditProfile] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [newVal, setnewVal] = useState({
    id: props.distributor.customer_id["id"],
  });
  const [otp, setotp] = useState();
  const [uploadlogo, setuploadlogo] = useState(false);
  const [logo, setlogo] = useState();
  const [matched, setmatched] = useState();
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});

  const loc = useLocation();
  const data = { id: props.distributor.customer_id["id"] };

  useEffect(() => {
    setbasic(props.distributor);
  }, [props.distributor]);

  const handleChange = (e) => {
    if (
      [
        "jpeg",
        "png",
        "jpg",
        "gif",
        "apng",
        "svg",
        "bmp",
        "bmp ico",
        "png ico",
      ].includes(e.target.files[0].name.split(".")[1])
    ) {
      setlogo({
        id: props.distributor.customer_id["id"],
        logo: e.target.files[0],
      });
    } else {
      NotificationManager.error("Invalid file format", "Wrong format", 200);
    }
  };
  function refresh() {
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "distributor/detail/" +
      basic.customer_id["id"] +
      "/";
    const res = getobj(url);
    res.then((res) => {
      // setbasic(res);
      props.setdistributor && props.setdistributor(res);
      props.setdistributorname && props.setdistributorname(res.company_name);
      if (loc.pathname === "/distributor") {
        props.setrefresh(!props.refresh);
      }
    });
  }

  const updateProfile = (data) => {
    const val = validateForms(data, customer);
    if (val.success) {
      if (validated(data)) {
        const url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
        const res = updateobj(url, data);
        console.log("res:", res);
        res
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              return response;
            }
            throw new Error(response);
          })
          .then(function (res) {
            refresh();
            seteditProfile(false);

            //setrefresh(!refreshed);
            NotificationManager.remove(NotificationManager.listNotify[0]);

            NotificationManager.success(res.Message);
          })
          .catch((err) => {
            console.log(err);
            seteditProfile(false);

            NotificationManager.remove(NotificationManager.listNotify[0]);

            NotificationManager.error(err.Message);
          });
      } else {
        setnewVal({ id: props.distributor.customer_id["id"] });
        seteditProfile(false);

        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error("No fields can be left blank");
      }
    } else {
      setErrors(val.data);
      return;
    }
    console.log(data);
  };

  const updatelogo = async (data) => {
    console.log(data);
    const url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
    const uploadData = new FormData();
    uploadData.append("id", data.id);
    uploadData.append("logo", data.logo);
    await fetch(url, {
      headers: {
        Authorization: "Token " + sessionStorage.getItem("token"),
        "X-CSRFToken": Cookies.get("csrftoken"),
      },
      method: "PATCH",
      body: uploadData,
    })
      .then((res) => {
        console.log(res);
        setuploadlogo(false);
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Updated Successfully");
        refresh();

        // if (loc.pathname == "/customer") {
        //   customerContest.setmanage({
        //     ...manage,
        //     refresh: !manage.refresh,
        //   });
        // }
      })
      .catch((err) => {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(err.Message);
      });
  };
  const updateCustomerInfo = () => {
    const val = validateForms(newVal, profile);
    if (val.success) {
      const url =
        process.env.REACT_APP_ZEWA_URL + "user/update/" + newVal["id"] + "/";
      const res = updateobj(url, newVal);
      res
        .then((response) => {
          console.log(response.status);
          if (response.status === 200) {
            return response;
          }
          throw new Error(response);
        })
        .then(function (res) {
          setcustomerinfo(false);

          console.log(res, "update-customer-info");
          // if (res.Message)
          refresh();
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(res.Message);
        })
        .catch((err) => {
          setcustomerinfo(false);

          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(err.Message);
        });
    } else {
      setErrors(val.data);
      return;
    }
  };

  const handleNewChange = (e) => {
    const { name, value } = e.target;
    setnewVal({
      ...newVal,
      [name]: value,
    });
  };

  const handleChangePassword = (data) => {
    const url = process.env.REACT_APP_ZEWA_URL + "user/update-password/";
    if (validated(data)) {
      const res = updateobj(url, data);
      res
        .then((res) => {
          console.log(res);
          setChangePassword(false);
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Updated Successfully");
          refresh();
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(err.Message);
        });
    } else {
      setnewVal({ id: props.distributor.customer_id["id"] });

      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("No fields can be left blank");
    }
  };

  return (
    <div>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableBody>
            <TableRow>
              <TableCell> Company Name:</TableCell>{" "}
              <TableCell>{basic.company_name}</TableCell>
              <TableCell>
                <Button
                  onClick={() => {
                    seteditProfile(true);
                    setErrors({});
                  }}
                  startIcon={<EditIcon color="primary" />}
                ></Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Name</TableCell>
              <TableCell>
                {basic.customer_id["first_name"] +
                  " " +
                  basic.customer_id["last_name"]}
              </TableCell>
              <TableCell>
                <Button
                  onClick={() => {
                    setcustomerinfo(true);
                    setErrors({});
                  }}
                  startIcon={<EditIcon color="primary" />}
                ></Button>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell> Email</TableCell>
              <TableCell>{basic.customer_id["email"]}</TableCell>
              <TableCell>
                <Button
                  onClick={() => setupdateemaildialogue(true)}
                  startIcon={<EditIcon color="primary" />}
                ></Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Phone:</TableCell>
              <TableCell>{basic.customer_id["phone_number"]}</TableCell>
              <TableCell></TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Company Address:</TableCell>
              <TableCell>{basic.company_address}</TableCell>
              <TableCell></TableCell>
            </TableRow>
            <TableRow>
              <TableCell> City:</TableCell>
              <TableCell>{basic.city}</TableCell>
              <TableCell></TableCell>
            </TableRow>
            <TableRow>
              <TableCell> State:</TableCell>
              <TableCell>{basic.state}</TableCell>
              <TableCell></TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Zip Code:</TableCell>{" "}
              <TableCell>{basic.zip_code}</TableCell>
              <TableCell></TableCell>
            </TableRow>

            {loc.pathname === "/admin" && (
              <TableRow>
                <TableCell> Change Password:</TableCell> <TableCell></TableCell>
                <TableCell>
                  <Button onClick={() => setChangePassword(true)}>
                    Change
                  </Button>
                </TableCell>
              </TableRow>
            )}

            <TableRow>
              <TableCell> Logo:</TableCell>{" "}
              <TableCell>
                <img src={basic.logo} style={logoStyle} alt="logo" />
                {/* "http://127.0.0.1:8000" + */}
              </TableCell>
              <TableCell>
                <Button
                  onClick={() => {
                    setuploadlogo(true);
                  }}
                >
                  Change
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={editProfile} onClose={() => seteditProfile(false)}>
        <DialogTitle>Update Profile</DialogTitle>

        <TextField
          id="outlined-basic"
          name="company_name"
          label="Enter Comapny Name"
          defaultValue={basic && basic.company_name}
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.company_name ? errors.company_name : ""}
          error={errors.company_name || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter Company Address"
          defaultValue={basic && basic.company_address}
          name="company_address"
          variant="outlined"
          sx={textfield}
          helperText={errors.company_address ? errors.company_address : ""}
          error={errors.company_address || false}
          onChange={handleNewChange}
        />
        <TextField
          id="outlined-basic"
          label="Enter City"
          defaultValue={basic && basic.city}
          name="city"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.city ? errors.city : ""}
          error={errors.city || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter State"
          defaultValue={basic && basic.state}
          name="state"
          sx={textfield}
          variant="outlined"
          onChange={handleNewChange}
          helperText={errors.state ? errors.state : ""}
          error={errors.state || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter Zip Code"
          defaultValue={basic && basic.zip_code}
          name="zip_code"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.zip_code ? errors.zip_code : ""}
          error={errors.zip_code || false}
        />

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setnewVal({ id: props.distributor.customer_id["id"] });

              seteditProfile(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              //console.log("clicked");
              updateProfile(newVal);
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={customerinfo} onClose={() => setcustomerinfo(false)}>
        <DialogTitle>Update Profile</DialogTitle>

        <TextField
          id="outlined-basic"
          name="first_name"
          label="Enter First Name"
          defaultValue={basic && basic.customer_id["first_name"]}
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.first_name ? errors.first_name : ""}
          error={errors.first_name || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter Last Name"
          defaultValue={basic && basic.customer_id["last_name"]}
          name="last_name"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.last_name ? errors.last_name : ""}
          error={errors.last_name || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter Phone Number"
          defaultValue={basic && basic.customer_id["phone_number"]}
          name="phone_number"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.phone_number ? errors.phone_number : ""}
          error={errors.phone_number || false}
        />

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => setcustomerinfo(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // console.log("clicked");
              updateCustomerInfo(newVal);
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={updateemailDialogue}
        onClose={() => setupdateemaildialogue(false)}
      >
        <DialogTitle>Update Profile</DialogTitle>

        <TextField
          id="outlined-basic"
          name="email"
          label="Enter Email"
          defaultValue={basic && basic.customer_id["email"]}
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          disabled={otp ? true : false}
        />
        {otp && (
          <>
            <div
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                fontSize: "14px",
                color: "#1976d2",
              }}
            >
              OTP has been sent to your new email address. Please enter it below
              to verify.
            </div>
            <TextField
              id="outlined-otp"
              name="otp"
              label="Enter OTP"
              placeholder="6-digit OTP"
              variant="outlined"
              sx={textfield}
              value={matched || ""}
              onChange={(e) => {
                setmatched(e.target.value);
              }}
              autoFocus
            />
          </>
        )}

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setupdateemaildialogue(false);
              setotp(null);
              setmatched(null);
              setnewVal({ id: props.distributor.customer_id["id"] });
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (
                !newVal.email ||
                newVal.email === basic.customer_id["email"]
              ) {
                NotificationManager.error(
                  "Please enter a new email address",
                  "Error",
                  2000,
                );
                return;
              }

              if (otp) {
                if (!matched) {
                  NotificationManager.error(
                    "Please enter the OTP",
                    "Error",
                    2000,
                  );
                  return;
                }

                // Send OTP to backend for verification
                const url =
                  process.env.REACT_APP_ZEWA_URL +
                  "user/update/" +
                  newVal["id"] +
                  "/?email=true&otp=true";

                // Send the OTP along with email for verification
                const verificationData = {
                  ...newVal,
                  otp: matched,
                };

                const res = updateobj(url, verificationData);
                res
                  .then((response) => {
                    console.log("OTP Verification Response:", response);
                    if (response?.status === 200 || response?.Message) {
                      setotp(null);
                      setmatched(null);
                      setnewVal({ id: props.distributor.customer_id["id"] });
                      NotificationManager.remove(
                        NotificationManager.listNotify[0],
                      );

                      NotificationManager.success(
                        response?.Message || "Email updated successfully",
                      );
                      refresh();
                      setupdateemaildialogue(false);
                    } else {
                      throw new Error(response);
                    }
                  })
                  .catch((err) => {
                    NotificationManager.remove(
                      NotificationManager.listNotify[0],
                    );

                    NotificationManager.error(
                      err?.Message ||
                        "OTP verification failed. Please enter the correct OTP.",
                      "Failed",
                      2000,
                    );
                  });
              } else {
                const url =
                  process.env.REACT_APP_ZEWA_URL +
                  "user/update/" +
                  newVal["id"] +
                  "/?email=true";
                const res = updateobj(url, newVal);
                res
                  .then((response) => {
                    console.log("OTP Send Response:", response);

                    // Backend sends OTP to email and confirms with status 200
                    // We don't need to extract OTP - just show the input field
                    if (response?.status === 200 || response?.message) {
                      // Set otp to true (as a flag, not the actual OTP)
                      setotp(true);
                      NotificationManager.success(
                        "OTP sent to your new email address",
                        "Success",
                        2000,
                      );
                    } else {
                      throw new Error(response);
                    }
                  })
                  .catch((err) => {
                    console.error("OTP Send Error:", err);
                    NotificationManager.error(
                      err?.Message ||
                        "Failed to send OTP. Please check your email address.",
                      "Error",
                      2000,
                    );
                  });
              }
            }}
          >
            {otp ? "Verify OTP" : "Send OTP"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={changePassword} onClose={() => setChangePassword(false)}>
        <DialogTitle>Change Password</DialogTitle>

        <TextField
          id="outlined-basic"
          name="new_password"
          sx={textfield}
          type={show ? "text" : "password"}
          label="Enter Password"
          variant="outlined"
          onChange={handleNewChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {show ? (
                  <VisibilityOff
                    onClick={() => {
                      setShow(false);
                    }}
                  />
                ) : (
                  <Visibility
                    onClick={() => {
                      setShow(true);
                    }}
                  />
                )}
              </InputAdornment>
            ),
          }}
        />

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => setChangePassword(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setChangePassword(false);
              setnewVal({ id: props.distributor.customer_id["id"] });
              handleChangePassword(newVal);
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={uploadlogo}
        onClose={() => setuploadlogo(false)}
        maxWidth={max_width}
        sx={{ padding: "5px", margin: "5px" }}
      >
        <DialogTitle>Upload Logo</DialogTitle>
        <div style={{ padding: "10px" }}>
          <input
            type="file"
            name="logo"
            style={{
              margin: "5px",
              padding: "5px",
            }}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          <p style={lebelStyle}>
            logo size should be 90 * 100 pixels
            <br /> Accepted formats: jpeg, gif, png, apng, svg, bmp, bmp ico,
            png ico.
          </p>
        </div>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={(e) => {
              setuploadlogo(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              updatelogo(logo);
            }}
          >
            upload
          </Button>
        </DialogActions>
      </Dialog>
      <NotificationContainer />
    </div>
  );
}
